import { Component, QueryList, ViewChildren } from '@angular/core';
import {
  AddEditCourseMasterType,
  ExamCourseMaster,
} from './enum/course-master.enum';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  IAddEditExamCourseMasterParam,
  ICourse,
  ICourseMasterData,
  ICreateCourseMaster,
  IExamCourseMasterRequest,
  IUpdateCourseMaster,
} from './interface/course-master.interface';
import { CourseMasterService } from './services/course-master.service';
import { ActivatedRoute, Router } from '@angular/router';
import { IDropdownListCode } from '../add-edit-exam-agency/interface/exam-agency.interface';
import { ToastrService } from 'ngx-toastr';
import { UserAuthDetails } from 'src/app/Services/user-sessions/user-auth-details';
import { forkJoin } from 'rxjs';
import { options2 } from './config/tiny-mce.config';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICourseMaster } from '../interfaces/exam-agency.interface';
import {
  NgbdSortableHeader,
  SortEvent,
} from 'src/app/directives/sort.directive';
import { compare } from '../exam-agencies.component';
import { StateKey } from '@angular/platform-browser';
import { StateService } from 'src/app/Services/stateServices/state.service';
import { TinyEditorModalComponent } from 'src/app/common/tiny-editor-modal/tiny-editor-modal.component';
import { CloneCourseModalComponent } from './clone-course-modal/clone-course-modal.component';

@Component({
  selector: 'app-course-master-add-edit',
  templateUrl: './course-master-add-edit.component.html',
  styleUrls: ['./course-master-add-edit.component.css'],
})
export class CourseMasterComponent {
  public courseMasterMode: ExamCourseMaster;
  public locationCode: Array<IDropdownListCode> = [];
  public courseCategoryType: Array<IDropdownListCode> = [];
  public examLevelType: Array<IDropdownListCode> = [];
  public examDifficultLevelType: Array<IDropdownListCode> = [];
  public previewTextDisplayFLag: boolean = false;
  public courseList: Array<ICourse> = [];
  public tinyMceOption: Object = options2;
  public courseMaster: ICourseMasterData;
  public sortColumn: keyof any;
  public sortDirection: 'asc' | 'desc' | '' = '';


  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  unSortedCourseList: ICourse[];
  selectedCourse: number | null = null;
  constructor(
    private readonly route: ActivatedRoute,
    private readonly courseMasterService: CourseMasterService,
    private readonly toaster: ToastrService,
    private readonly router: Router,
    private stateService: StateService,
    private modalService: NgbModal
  ) {
    this.retrieveLoggedInUserId();
    this.selectedCourse = this.stateService.getCourse_Id();
  }
  selectCourse(course: ICourse) {
    this.selectedCourse = course.Course_Id;
    this.stateService.setCourse_IdState(course.Course_Id);
  }

  examAgencyRequestParam: IExamCourseMasterRequest = {
    loggedInUserId: '',
    examAgencyId: '',
    courseMasterId: '',
    examAgencyName: '',
  };
  addEditExamCourseMaster = new FormGroup({
    LoggedInUserID: new FormControl(),
    Course_Master_Id: new FormControl(),
    Exam_Agency_Id: new FormControl(),
    Course_Name: new FormControl('', [Validators.required]),
    Location_Id: new FormControl('', [Validators.required]),
    Location_Name: new FormControl(),
    Exam_Short_Name: new FormControl('', [Validators.required]),
    Course_Description: new FormControl(),
    Exam_Level_Type_Code: new FormControl('', [Validators.required]),
    Exam_Difficulty_Level_Type_Code: new FormControl('', [Validators.required]),
    Course_Category_Type_Code: new FormControl('', [Validators.required]),
    Exam_Agency_Name: new FormControl(),
    Exam_Level_Type_Name: new FormControl(),
    Exam_Difficulty_Level_Type_Name: new FormControl(),
    Course_Category_Type_Name: new FormControl(),
    Number_Of_Question: new FormControl(),
    Total_Test_Score: new FormControl(),
    Exam_Duration: new FormControl(),
  });
  formInitalValue: string;

  ngOnInit() {
    this.checkExamModeEditOrAdd();
    this.getExamAgencyDetail();
    this.fetchDropDownList();

    this.addEditExamCourseMaster.get('Exam_Agency_Name')?.disable();
    this.formInitalValue = JSON.stringify(this.addEditExamCourseMaster.value);
  }

  get truncatedDescription(): string {
  const raw = this.addEditExamCourseMaster.value.Course_Description || '';
  const tmp = document.createElement('div');
  tmp.innerHTML = raw;                     // parse HTML
  const text = tmp.textContent || tmp.innerText || '';

  const maxLength = 100;                   // set your limit
  return text.length > maxLength
    ? text.substring(0, maxLength) + '…'
    : text;
}

async openDescritionEditor(){
    const modalRef = this.modalService.open(
      TinyEditorModalComponent,
      { size: 'xl', backdrop: 'static', centered: true }
    );
  const current = this.addEditExamCourseMaster.get('Course_Description')?.value || '';
  modalRef.componentInstance.description = current;

  try {
    const updated: string = await modalRef.result; // resolves on .close()
    this.addEditExamCourseMaster.patchValue({ Course_Description: updated });
    this.addEditExamCourseMaster.get('Course_Description')?.markAsDirty();
    this.addEditExamCourseMaster.get('Course_Description')?.markAsTouched();
  } catch {
    // dismissed (Cancel / ESC / backdrop) — do nothing
  }
}


  private checkExamModeEditOrAdd() {
    const { type, examAgencyId, courseMasterId, examAgencyName } = this.route
      .snapshot.queryParams as IAddEditExamCourseMasterParam;
    this.courseMasterMode = type as ExamCourseMaster;

    this.examAgencyRequestParam.examAgencyId = examAgencyId;
    this.examAgencyRequestParam.courseMasterId = courseMasterId;
    this.examAgencyRequestParam.examAgencyName = examAgencyName;
  }
  public getAlignment(value: any) {
    switch (typeof value) {
      case 'number':
        return 'justify-content-end';
      case 'string':
        return 'justify-content-start';
      case 'object':
        if (value instanceof Date) {
          return 'justify-content-start';
        } else if (value === null) {
          return '';
        } else {
          return '';
        }

      default:
        return '';
    }
  }

  getExamAgencyDetail() {
    if (!this.canMakeRequest()) {
      return;
    }

    if (!this.examAgencyRequestParam.courseMasterId) {
      this.addEditExamCourseMaster
        .get('LoggedInUserID')
        ?.setValue(this.examAgencyRequestParam.loggedInUserId);
      this.addEditExamCourseMaster
        .get('Exam_Agency_Id')
        ?.setValue(+this.examAgencyRequestParam.examAgencyId);
      this.addEditExamCourseMaster
        .get('Exam_Agency_Name')
        ?.setValue(this.examAgencyRequestParam.examAgencyName);
      return;
    }

    this.courseMasterService
      .getCourseMasterById<Array<ICourseMasterData>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.examAgencyId,
        this.examAgencyRequestParam.courseMasterId
      )
      .subscribe((data) => {
        this.courseMaster = data[0];
        this.patchDataInForm(data[0] || {});
        this.getCourses();
      });
  }

  patchDataInForm(courseMasterData: ICourseMasterData) {
    this.addEditExamCourseMaster.patchValue({
      LoggedInUserID: this.examAgencyRequestParam.loggedInUserId,
      ...courseMasterData,
    });
    this.formInitalValue = JSON.stringify(this.addEditExamCourseMaster.value);
  }

  private fetchDropDownList() {
    forkJoin([
      this.courseMasterService.getDropdownList<IDropdownListCode>('LOCATION'),
      this.courseMasterService.getDropdownList<IDropdownListCode>(
        'COURSE_CATEGORY_TYPE'
      ),
      this.courseMasterService.getDropdownList<IDropdownListCode>(
        'EXAM_LEVEL_TYPE'
      ),
      this.courseMasterService.getDropdownList<IDropdownListCode>(
        'EXAM_DIFFICULTY_LEVEL_TYPE'
      ),
    ]).subscribe((elem) => {
      const [
        location,
        courseCategoryType,
        examLevelType,
        examDifficultLevelType,
      ] = elem as unknown as Array<Array<IDropdownListCode>>;
      this.locationCode = location;
      this.courseCategoryType = courseCategoryType;
      this.examLevelType = examLevelType;
      this.examDifficultLevelType = examDifficultLevelType;
    });
  }

  onSubmit() {
    if (this.addEditExamCourseMaster.invalid) {
      this.toaster.error('Please fill required field', 'Warning');
      return false;
    }

    let formValue: ICourseMasterData | IUpdateCourseMaster;

    if (this.courseMasterMode === ExamCourseMaster.ADD) {
      formValue = this.saveExamAgencyModel(
        AddEditCourseMasterType.CREATE
      ) as unknown as ICourseMasterData;

      this.courseMasterService
        .createCourseMaster<ICourseMaster>(
          formValue as unknown as ICreateCourseMaster
        )
        .subscribe((elem) => {
          this.toaster.success('Saved Successfully', 'Success');
          this.router.navigateByUrl('/Exam/ExamAgencies');
        });
    } else if (this.courseMasterMode === ExamCourseMaster.EDIT) {
      formValue = this.saveExamAgencyModel(
        AddEditCourseMasterType.UPDATE
      ) as unknown as IUpdateCourseMaster;

      this.courseMasterService
        .updateCourseMaster<ICourseMaster>(formValue)
        .subscribe((elem) => {
          this.toaster.success('Saved Successfully', 'Success');
          this.router.navigateByUrl('/Exam/ExamAgencies');
        });
    } else {
      formValue = {} as ICourseMasterData;
    }

    this.addEditExamCourseMaster.markAsPristine();
    this.addEditExamCourseMaster.markAsUntouched();

    return;
  }

  getError(formField: string) {
    return this.addEditExamCourseMaster.get(formField)?.hasError('required') &&
      this.addEditExamCourseMaster.get(formField)?.touched
      ? true
      : false;
  }

  clear() {
    const currentValues = this.addEditExamCourseMaster.value;
    const isPristine = JSON.stringify(currentValues) === this.formInitalValue;
    if (isPristine) {
      this.addEditExamCourseMaster.markAsPristine();
    } else {
    }
    if (this.addEditExamCourseMaster.dirty) {
      const flag = window.confirm('Do you want to save the changes');

      if (flag) {
        this.onSubmit();
      } else {
        this.router.navigateByUrl('/Exam/ExamAgencies');
      }
    } else {
      // this.addEditExamCourseMaster.reset();
      this.router.navigateByUrl('/Exam/ExamAgencies');
    }
  }

  /**
   * Checking Guards for making internal request
   *
   * @returns boolean
   */
  private canMakeRequest() {
    return this.examAgencyRequestParam.loggedInUserId ? true : false;
  }

  /**
   * Get User id from Local Storage
   */
  retrieveLoggedInUserId() {
    const loggedInUserId = UserAuthDetails.getUserLoggedInId();

    if (!loggedInUserId)
      return this.toaster.error('Please Provide Logged in User Id', 'Error');

    this.examAgencyRequestParam.loggedInUserId = loggedInUserId;
    return null;
  }

  saveExamAgencyModel(type: AddEditCourseMasterType) {
    if (type === AddEditCourseMasterType.CREATE) {
      return {
        LoggedInUserID: this.addEditExamCourseMaster.value.LoggedInUserID,
        CourseName: this.addEditExamCourseMaster.value.Course_Name || '',
        ExamShortName: this.addEditExamCourseMaster.value.Exam_Short_Name || '',
        ExamAgencyID: this.addEditExamCourseMaster.value.Exam_Agency_Id,
        LocationID: this.addEditExamCourseMaster.value.Location_Id || '',
        CourseDescription:
          this.addEditExamCourseMaster.value.Course_Description || '',
        ExamLevelTypeCode:
          this.addEditExamCourseMaster.value.Exam_Level_Type_Code || '',
        ExamDifficultyLevelTypeCode:
          this.addEditExamCourseMaster.value.Exam_Difficulty_Level_Type_Code ||
          '',
        CourseCategoryTypeCode:
          this.addEditExamCourseMaster.value.Course_Category_Type_Code || '',
        ExamDuration: this.addEditExamCourseMaster.value.Exam_Duration || null,
        NumberOfQuestion:
          this.addEditExamCourseMaster.value.Number_Of_Question || null,
        TotalTestScore:
          this.addEditExamCourseMaster.value.Total_Test_Score || null,
      };
    } else if (type === AddEditCourseMasterType.UPDATE) {
      return {
        LoggedInUserID: this.addEditExamCourseMaster.value.LoggedInUserID,
        CourseName: this.addEditExamCourseMaster.value.Course_Name || '',
        CourseMasterID: this.addEditExamCourseMaster.value.Course_Master_Id,
        ExamShortName: this.addEditExamCourseMaster.value.Exam_Short_Name || '',
        ExamAgencyID: this.addEditExamCourseMaster.value.Exam_Agency_Id,
        LocationID: this.addEditExamCourseMaster.value.Location_Id || '',
        CourseDescription:
          this.addEditExamCourseMaster.value.Course_Description || '',
        ExamLevelTypeCode:
          this.addEditExamCourseMaster.value.Exam_Level_Type_Code || '',
        ExamDifficultyLevelTypeCode:
          this.addEditExamCourseMaster.value.Exam_Difficulty_Level_Type_Code ||
          '',
        CourseCategoryTypeCode:
          this.addEditExamCourseMaster.value.Course_Category_Type_Code || '',
        ExamDuration: this.addEditExamCourseMaster.value.Exam_Duration || null,
        NumberOfQuestion:
          this.addEditExamCourseMaster.value.Number_Of_Question || null,
        TotalTestScore:
          this.addEditExamCourseMaster.value.Total_Test_Score || null,
      };
    }
    return;
  }

  public displayDialogOff() {
    this.previewTextDisplayFLag = false;
  }

  public getCourses() {
    this.courseMasterService
      .getCourses<Array<ICourse>>(
        this.examAgencyRequestParam.loggedInUserId,
        this.examAgencyRequestParam.courseMasterId,
        '',
        'ADMIN',
        ''
      )
      .subscribe((courses) => {
        this.courseList = courses;
        this.unSortedCourseList = courses;
      });
  }

  preventEnteringString(event: KeyboardEvent, maxLen: number) {
    if (Number.isNaN(+event.key)) {
      return false;
    }

    if (((event.target as any)?.value || '').length > maxLen - 1) {
      return false;
    }

    return true;
  }

  addCourse() {
    this.router.navigateByUrl(
      `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Add`
    );
  }

  cloneCourse(course: ICourse, event: Event) {
    event.stopPropagation();
    const modalRef = this.modalService.open(CloneCourseModalComponent, {
      size: 'xl',
      backdrop: 'static',
      centered: true,
    });

    modalRef.componentInstance.loggedInUserId = this.examAgencyRequestParam.loggedInUserId;
    modalRef.componentInstance.sourceExamAgencyId = this.addEditExamCourseMaster.get('Exam_Agency_Id')?.value;
    modalRef.componentInstance.sourceExamAgencyName = this.addEditExamCourseMaster.get('Exam_Agency_Name')?.value;
    modalRef.componentInstance.sourceCourseMasterId = this.addEditExamCourseMaster.get('Course_Master_Id')?.value;
    modalRef.componentInstance.sourceCourseName = this.addEditExamCourseMaster.get('Course_Name')?.value;
    modalRef.componentInstance.sourceCourse = course;

    modalRef.result.then(
      (result) => {
        if (result?.cloned) {
          this.getCourses();
        }
      },
      () => {
        // dismissed
      }
    );
  }

  editCourse(courseId: number) {
    this.selectedCourse = courseId;
    this.stateService.setCourse_IdState(courseId);
    this.router.navigateByUrl(
      `Exam/ExamAgencies/CourseMaster/Course/ViewEdit?courseMasterId=${this.examAgencyRequestParam.courseMasterId}&examAgencyId=${this.examAgencyRequestParam.examAgencyId}&type=Edit&courseId=${courseId}`
    );
  }



private readonly MONTHS = [
  'January','February','March','April','May','June',
  'July','August','September','October','November','December'
];

// Map full + 3-letter names (lowercased) → month number
private readonly MONTHS_MAP: Record<string, number> = (() => {
  const map: Record<string, number> = {};
  const months = [
    'January','February','March','April','May','June',
    'July','August','September','October','November','December'
  ];
  months.forEach((name, i) => {
    const n = i + 1;
    map[name.toLowerCase()] = n;                // "february"
    map[name.slice(0,3).toLowerCase()] = n;     // "feb"
  });
  return map;
})();

private toMonthNum(m: any): number {
  if (m == null) return NaN;

  // numeric inputs: 1..12 or "01".."12"
  const asNum = Number(m);
  if (!Number.isNaN(asNum) && asNum >= 1 && asNum <= 12) return asNum;

  // string inputs: "Feb", "FEB", "February", etc.
  const key = String(m).trim().toLowerCase();
  return this.MONTHS_MAP[key] ?? NaN;
}

formatYearMonth(year: any, month: any): string {
  const n = this.toMonthNum(month);
  if (!year || Number.isNaN(n)) return String(year ?? '');
  const mm = String(n).padStart(2, '0');
  const name = this.MONTHS[n - 1]; // Capitalized name for display
  return `${year}-${mm} : ${name}`;
}


public onSort({ column, direction }: SortEvent) {
  // reset other headers
  this.headers.forEach(h => {
    if (h.sortable !== column) h.direction = '';
  });

  if (!direction || !column) {
    this.courseList = this.unSortedCourseList;
    this.sortColumn = '';
    this.sortDirection = '';
    return;
  }

  this.sortColumn = column;
  this.sortDirection = direction;

  const dir = direction === 'asc' ? 1 : -1;

  this.courseList = [...this.unSortedCourseList].sort((a: any, b: any) => {
    // helper compare
    const cmp = (x: any, y: any) => (x < y ? -1 : x > y ? 1 : 0);

    if (column === 'Exam_Year') {
      // Year first
      let res = cmp(a.Exam_Year, b.Exam_Year);
      if (res === 0) {
        // Then numeric month
        const am = this.toMonthNum(a.Exam_Month);
        const bm = this.toMonthNum(b.Exam_Month);
        res = cmp(am, bm);
      }
      return res * dir;
    }

    if (column === 'Exam_Month') {
      // Sort by year, then numeric month (so months line up within a year)
      let res = cmp(a.Exam_Year, b.Exam_Year);
      if (res === 0) {
        const am = this.toMonthNum(a.Exam_Month);
        const bm = this.toMonthNum(b.Exam_Month);
        res = cmp(am, bm);
      }
      return res * dir;
    }

    // default compare for other columns
    const res = cmp(a[column], b[column]);
    return res * dir;
  });
}


}
